import React from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';

/**
 * DeletionButton component for delete actions
 * Provides different styling for admin vs user deletions
 */
const DeletionButton = ({
  isAdmin = false,
  onClick,
  disabled = false,
  size = 'md',
  className = ''
}) => {
  // Size variants
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  // Style variants based on user type
  const baseClasses = `
    inline-flex items-center space-x-1 rounded font-medium transition-colors duration-200
    focus:outline-none focus:ring-2 focus:ring-offset-2
    ${sizeClasses[size]}
  `;

  const adminClasses = `
    text-red-600 hover:text-red-700 bg-red-50 hover:bg-red-100
    dark:text-red-400 dark:bg-red-900/20 dark:hover:bg-red-900/30
    focus:ring-red-500 border border-red-200 dark:border-red-800
  `;

  const userClasses = `
    text-gray-600 hover:text-gray-700 bg-gray-50 hover:bg-gray-100
    dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700
    focus:ring-gray-500 border border-gray-200 dark:border-gray-600
  `;

  const disabledClasses = `
    opacity-50 cursor-not-allowed
  `;

  const buttonClasses = `
    ${baseClasses}
    ${isAdmin ? adminClasses : userClasses}
    ${disabled ? disabledClasses : ''}
    ${className}
  `;

  const tooltipText = isAdmin 
    ? 'Delete as moderator' 
    : 'Delete your content';

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={buttonClasses}
      title={tooltipText}
      aria-label={tooltipText}
    >
      <TrashIcon className={iconSizes[size]} />
      <span>Delete</span>
    </button>
  );
};

export default DeletionButton;